module.exports = __webpack_public_path__ + "static/media/993480.2402959a.png";